import React, { FC, useState } from 'react';
import { StyledTab, StyledTabs } from './Atoms';
import { TabPanel } from './TabPanel';
import { TabbedContentData } from './types';
import { useAppSelector } from '../../hooks/useAppDispatch';

type TabsProps = {
  content: TabbedContentData[];
  hideTabs?: boolean;
  ariaPrefix?: string;
  onChange?: (newValue: number) => void;
  value?: number;
};

export const TabbedContent: FC<TabsProps> = ({
  content,
  hideTabs,
  ariaPrefix,
  onChange,
  value,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedTab(newValue);
    onChange && onChange(newValue);
  };
  const sidepanel = useAppSelector((state) => state.sidepanel.sidepanel);
  return (
    <>
      {!hideTabs && (
        <StyledTabs
          indicatorColor="primary"
          value={value == null ? selectedTab : value}
          onChange={handleChange}
          style={{ width: `${sidepanel?.width}px` }}
          TabIndicatorProps={{
            style: { display: 'none' },
          }}
        >
          {content.map((data: TabbedContentData, index: number) => (
            <StyledTab
              className={`${selectedTab === index ? 'active' : ''} ${
                data.classname ? data.classname : ''
              }`}
              key={index}
              label={data.title}
              id={`${ariaPrefix != null ? `${ariaPrefix}-` : ''}tab-${index}`}
              aria-controls={`${ariaPrefix != null ? `${ariaPrefix}-` : ''}tabpanel-${index}`}
              style={{ width: `${(1 / content.length) * 100}%` }}
              fullWidth
            />
          ))}
        </StyledTabs>
      )}
      {content.map((data: TabbedContentData, index: number) => (
        <TabPanel
          key={index}
          index={index}
          value={value == null ? selectedTab : value}
          hideTabs={hideTabs}
        >
          {data.data}
        </TabPanel>
      ))}
    </>
  );
};
